import { Header } from "@/components/quiz/explainers/header";
import { Button } from "@workspace/ui/components/button";
import { IFertilityJourneyStep } from "./types";
import { StepCard } from "./step-card";

export function FertilityJourneyExplainer2({
  title,
  description,
  steps,
  handleNext,
}: {
  title: string;
  description: string;
  steps: IFertilityJourneyStep[];
  handleNext: () => void;
}) {
  return (
    <>
      <div className="flex flex-1 flex-col gap-5 overflow-y-auto min-h-0 pb-12">
        <Header title={title} description={description} />
        <StepCard steps={steps} />
      </div>
      <div className="sticky bottom-0 flex flex-col gap-3 pb-6">
        <Button onClick={handleNext} variant="default" className="w-full shrink-0">Next</Button>
      </div>
    </>
  );
}
